<template>
  <div>
    <div id="nav-scroller" ref="content">
      
      <!-- <Navbar ref="navbar"/> -->
      <div>
        <b-navbar
          v-b-scrollspy:nav-scroller
          ref="navbar"
          toggleable="md"
          type="dark"
          variant="dark"
          sticky>
          <b-navbar-brand href="#home"><img src="../assets/images/radix-logo.png"></b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item href="#home" @click="scrollIntoView">Home</b-nav-item>
                <b-nav-item href="#about" @click="scrollIntoView">About</b-nav-item>
            <!-- <b-nav-item-dropdown href="#about" text="About Us">
                <b-dropdown-item href="#values">Vision and Missions</b-dropdown-item>
                <b-dropdown-item>What We Do</b-dropdown-item>
            </b-nav-item-dropdown> -->
            <b-nav-item href="#services" @click="scrollIntoView">Services</b-nav-item>
            <b-nav-item href="#products" @click="scrollIntoView">Products</b-nav-item>
            <b-nav-item href="#collaborators" @click="scrollIntoView">Collaborators</b-nav-item>
            <b-nav-item href="#contact" @click="scrollIntoView">Contact</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
      <div class="quote-div">
        <section id="home">
          <Quote/>
        </section>
      </div>
      <div class="body-div">
        <section id="about">
          <About/>
        </section>
        <section id="services">
          <Services/>
        </section>
        <section id="products">
          <Products/>
        </section>
        <section id="collaborators">
          <Collaborators/>
        </section>
        <section id="contact">
          <Contact/>
        </section>
      </div>
      <Footer/>
    </div>
    
  </div>
  
</template>

<script>
// @ is an alias to /src
import Quote from '@/components/Quote.vue';
import Navbar from '@/components/Navbar.vue';
import About from '@/components/About.vue';
import Services from '@/components/Services.vue';
import Products from '@/components/Products.vue';
import Collaborators from '@/components/Collaborators.vue';
import Contact from '@/components/Contact.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  components: {
    Quote,
    Navbar,
    About,
    Services,
    Products,
    Collaborators,
    Contact,
    Footer
  },
  methods: {
    scrollIntoView(evt) {
        evt.preventDefault()
        const href = evt.target.getAttribute('href')
        const el = href ? document.querySelector(href) : null
        if (el) {
          this.$refs.content.scrollTop = el.offsetTop
        }
      },
  }
};
</script>

<style scoped>

#home {
  min-height: 100vh;
}

#nav-scroller {
  position: relative;
  overflow-y: scroll;
  height: 100vh;
  scroll-behavior: smooth;
}

.quote-div {
  background-image: url('../assets/images/quote-bg.jpg');
  background-size: 100%;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow:inset 0 0 0 2000px rgba(0,0,0,0.4);
}

.body-div {
  background-color: #052d3b;
}

section {
  padding: 4rem;
}

.navbar {
    height: 7rem;
    font-size: 1.2rem;
}

.navbar a {
    color: rgb(255,255,255);
}

.bg-dark {
  background-color: #052d3b !important;
}

/* .sticky {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #052d3b;
} */

.navbar img {
    max-height: 50px;
    margin-left: 1rem;
}

.navbar-dark .navbar-nav .nav-link {
    color: rgba(255,255,255, 1);
}

.nav-item .nav-link {
    background-color: #052d3b;
    z-index: 5;
}

.navbar-collapse {
  z-index: 10;
}

@media only screen and (max-width: 700px){
  section {
    padding: 2rem;
  }
}
</style>
